import React, { useState, useEffect } from 'react';

export default function VerifyEmail({ onNavigate }) {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const [resendEmail, setResendEmail] = useState('');
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMsg, setResendMsg] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('Verification link is missing a token.'); return; }
    fetch(`/api/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(r => r.json().then(d => ({ ok: r.ok, data: d })))
      .then(({ ok, data }) => {
        if (ok) { setStatus('success'); setMessage(data.message); }
        else { setStatus('error'); setMessage(data.error || 'Verification failed.'); }
      })
      .catch(() => { setStatus('error'); setMessage('Something went wrong. Please try again.'); });
  }, [token]);

  const handleResend = async (e) => {
    e.preventDefault();
    setResendLoading(true);
    await fetch('/api/auth/resend-verification', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: resendEmail.trim().toLowerCase() }),
    });
    setResendMsg('If that email is unverified, a new link has been sent. Check your inbox.');
    setResendLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold" style={{ color: '#1B3A5C' }}>Ministry AI Toolkit</h1>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 text-center">
          {status === 'loading' && (
            <>
              <div className="text-4xl mb-4">⏳</div>
              <h2 className="text-xl font-bold mb-2" style={{ color: '#1B3A5C' }}>Verifying your email...</h2>
              <p className="text-gray-400 text-sm">Just a moment.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="text-4xl mb-4">🎉</div>
              <h2 className="text-xl font-bold mb-2" style={{ color: '#1B3A5C' }}>Email Confirmed!</h2>
              <p className="text-gray-500 text-sm mb-6">{message}</p>
              <button
                onClick={() => onNavigate('login')}
                className="w-full py-2.5 rounded-lg text-white font-semibold transition-opacity hover:opacity-90"
                style={{ backgroundColor: '#C8921A' }}
              >
                Sign In
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="text-4xl mb-4">❌</div>
              <h2 className="text-xl font-bold mb-2" style={{ color: '#1B3A5C' }}>Verification Failed</h2>
              <p className="text-gray-500 text-sm mb-6">{message}</p>

              <div className="border-t border-gray-100 pt-6">
                <p className="text-sm text-gray-500 mb-4">Need a new link? Enter your email below:</p>
                {resendMsg ? (
                  <p className="text-sm text-green-600">{resendMsg}</p>
                ) : (
                  <form onSubmit={handleResend} className="flex gap-2">
                    <input
                      type="email"
                      value={resendEmail}
                      onChange={e => setResendEmail(e.target.value)}
                      placeholder="your@email.com"
                      required
                      className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900"
                    />
                    <button
                      type="submit"
                      disabled={resendLoading}
                      className="px-4 py-2 rounded-lg text-white text-sm font-semibold disabled:opacity-60"
                      style={{ backgroundColor: '#C8921A' }}
                    >
                      {resendLoading ? '...' : 'Resend'}
                    </button>
                  </form>
                )}
              </div>

              <button onClick={() => onNavigate('login')} className="text-sm font-medium hover:underline mt-4 block" style={{ color: '#1B3A5C' }}>
                ← Back to Sign In
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
